import { useLocalization } from "../localization";
import { useAccountReadiness } from "../providers/AccountReadinessProvider";
import { useAppBootstrap } from "../providers/AppBootstrapProvider";
import { useNotificationLocaleViewModel } from "./useNotificationLocaleViewModel";

export default function NotificationLocaleLifecycle() {
  const { currentUser } = useAppBootstrap();
  const readiness = useAccountReadiness();
  const { locale } = useLocalization();
  const userId = readiness.status === "complete" && readiness.uid === currentUser?.uid ? readiness.uid : null;
  useNotificationLocaleViewModel(userId, locale);
  return null;
}
